import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "greenStatus",
  "use": "greenStatus-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"greenStatus\"><path d=\"M5 .577a2 2 0 012 0l3.196 1.846a2 2 0 011 1.732v3.69a2 2 0 01-1 1.732L7 11.423a2 2 0 01-2 0L1.804 9.577a2 2 0 01-1-1.732v-3.69a2 2 0 011-1.732L5 .577z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id